import { LegacyMap, has, pageInfo } from './prism-new-legacy-maps.helpers';

/**
 * call-audit legacy maps. prism-new sends the whole `request_output` as `report`; the old API sent
 * only `request_output.report` there, with `callStatus` / `callType` lifted beside it.
 */
export function auditItem(r: any) {
  const output = r.report ?? {};
  return {
    ...r,
    score: r.score ?? 0,
    // Rows whose output is already the bare report keep it whole.
    report: output.report ?? r.report ?? {},
    callStatus: output.callStatus || 'UNKNOWN',
    callType: output.callType || r.agentLevel || 'UNKNOWN',
    errorMessage: output.errorReason ?? null,
    cheat_sheet_evaluation: r.cheatSheetEvaluation ?? output.cheat_sheet_evaluation,
  };
}

export const CALL_AUDIT_LEGACY_MAPS: Record<string, LegacyMap> = {
  'GET /call-audit/reports': (d, ctx) => {
    if (!Array.isArray(d?.reports)) return { data: d };
    const p = pageInfo(ctx, null, d.total);
    return { data: { results: d.reports.map(auditItem), pagination: { total: p.total, page: p.page, limit: p.limit, totalPages: p.totalPages } } };
  },
  // prism-new answers one `{ report }`; the old API listed every match as `{ results, total }`.
  'GET /call-audit/report-by-conversation-pid': (d) => {
    if (!has(d, 'report')) return { data: d };
    const results = d.report ? [auditItem(d.report)] : [];
    return { data: { results, total: results.length } };
  },
};
